import { createFileRoute, redirect } from "@tanstack/react-router";
import { appendSearch } from "~/components/lock/lockServiceRoutes";

export const Route = createFileRoute("/$hubMetaName/lock-b2c/new")({
	loader: (ctx) => {
		throw redirect({ href: appendSearch(`/${ctx.params.hubMetaName}/lock/new`, ctx.location.searchStr), replace: true });
	},
});
